import * as urlUtil from '@tencent/vft-common/url';
import Version from '@tencent/vft-atom/lib/Version';
import atom from '@tencent/vft-atom';
import { getPlayright } from './videoPlayright';

/**
 * 在 h5 或 小程序 或 native 中打开
 * @return {String} h5/ weapp/ native
 */
const openType = function () {
  const env = window.magicApp?.env;
  const version = env?.appVersion;

  if (!version) return 'h5';

  const vObj = new Version(version);

  if (!vObj.compare('8.20')) return 'h5';

  return 'native';
};

const weishiHandler = async function ({ cid, vid }) {
  if (!cid && !vid) return false;

  const { isWeishi } = window.magicApp?.env;

  if (!isWeishi) return false;

  const type = openType();

  if (type === 'h5') return false;

  if (type === 'native') {
    const data = await getPlayright({ cid, vid });
    // eslint-disable-next-line
    if (!vid) vid = data.vid;

    // 20 表示支持新闻客户端
    const { playright } = data.fields;
    if (!playright || !playright.includes('24')) return false;

    const url = urlUtil.buildUrl('weishi://horizontal_video?content_type=1', { cid, vid });
    atom.openUrl(url);
    return true;
  }

  return false;
};

export default weishiHandler;
